import { call } from 'typed-redux-saga';
import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
} from '@owl-frontend/redux';
import { createLogger } from '@owl-lib/logger';
import sessionApiClient from '../../api/session/client';
import { globalBus } from '../../context/event-bus';

const logger = createLogger(__filename);

enum NOTIFICATION {
  TemplateReady = 'template_ready',
  TemplateError = 'template_error',
}

export enum NOTIFICATION_EMIT_EVENTS {
  InvalidateTemplates = 'invalidate_templates',
  TemplateGenerationError = 'template_generation_error',
}

function* initializeWebSocket() {
  const socket = yield* call(sessionApiClient.ws);

  socket.onopen = () => {
    logger.info('WebSocket connection opened!');
  };

  socket.onmessage = (event) => {
    logger.info('Received message: %o', event);

    if (!event) {
      return;
    }

    const data = JSON.parse(event.data);

    if (data.notification_type === NOTIFICATION.TemplateReady) {
      globalBus.emit(
        NOTIFICATION_EMIT_EVENTS.InvalidateTemplates,
        data.dossier_id
      );
    }
    if (data.notification_type === NOTIFICATION.TemplateError) {
      globalBus.emit(
        NOTIFICATION_EMIT_EVENTS.TemplateGenerationError,
        data.dossier_id
      );
    }
  };

  socket.onerror = (event) => {
    logger.error(
      `WebSocket connection error! ${JSON.stringify(event, null, 2)}`
    );
  };

  socket.onclose = () => {
    logger.info('WebSocket connection closed.');
  };
}

export interface WebSocketState {
  actions: {
    initializeWebSocket: AsyncActionState;
  };
}

const initialState: WebSocketState = {
  actions: {
    initializeWebSocket: { status: 'uninitialized' },
  },
};

const slice = setupSlice('websocket', initialState).addAsyncSagas(
  {
    initializeWebSocket,
  },
  {
    timeoutLimit: -1,
  }
);

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
